<template>
  <div class="architecture">
    <div class="show-act-box">
      <div class="content-title">
        <div class="title-left">关于建筑</div>
        <div class="title-right">查看全部</div>
      </div>
      <div class="act-list">
        <ShowActBox
          :showData="{
            imageUrl:
              'http://c.vpimg1.com/upcb/2023/07/06/13/ias_1688636343067448260.jpg',
          }"
          v-for="item in actList2"
          :key="item"
        />
      </div>
    </div>
    <!-- <div class="share-box">
      <ShareQr />
    </div> -->
  </div>
</template>
<script>
// import ShareQr from "../components/shareQr.vue";
import ShowActBox from "../components/showActBox";
export default {
  name: "architecture",
  components: {
    // ShareQr,
    ShowActBox,
  },
  data() {
    return {
    actList2: [1, 2, 3, 4, 5, 6],
      lan: this.$store.state.isEn,
    };
  },
  watch: {
    pageIndex(val, oldval) {
      if (val !== oldval) {
        this.init();
      }
    },
    "$store.state.isEn"() {
      this.lan = this.$store.state.isEn;
      if (this.pageIndex !== 1) {
        this.pageIndex = 1;
      } else {
        this.init();
      }
    },
  },
  created() {
    localStorage.removeItem("path");
    localStorage.removeItem("columnId");
    this.init();
  },
  methods: {
  },
};
</script>
<style scoped>
.architecture {
  padding-top: 5%;
}
.share-box {
  position: absolute;
  right: 50px;
  top: 100px;
}
.show-act-box {
  width:100%;
  margin: 60px auto 90px;
}
.act-list {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.content-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.title-left {
  font-family: SourceHanSansCN-Bold;
  font-size: 40px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  font-weight: 700;
}
.title-right {
  position: relative;
  font-family: SourceHanSansCN-Regular;
  font-size: 20px;
  color: #98989f;
  text-align: left;
  font-weight: 400;
  padding-right: 15px;
  cursor: pointer;
}
.sub-title {
  font-family: SourceHanSansCN-Bold;
  font-size: 34px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  font-weight: 700;
  margin-top: 10px;
}
.title-right::after {
  content: "";
  position: absolute;
  top: 55%;
  right: 0px;
  width: 8px;
  height: 8px;
  border-top: 2px solid #666666;
  border-right: 2px solid #666666;
  -webkit-transform: translateY(-45%) rotate(45deg);
  transform: translateY(-45%) rotate(45deg);
  border-top-width: 1px;
  border-top-style: solid;
  border-top-color: #666666;
  border-right-width: 1px;
  border-right-style: solid;
  border-right-color: #666666;
}

@media (max-width: 960px) {
}
@media (max-width: 768px) {
}
@media (max-width: 480px) {
}
</style>
